import { Prototype } from '@core';
import { useFetchDashboardAllocationReportInfinity } from '@hooks';
import { onShowContainer } from '@pages/TransportJob/helpers';
import React, { memo, useCallback, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import trans from 'translation';
import { KButton, KColors, KContainer, KInput, KLabel, KLoading } from 'uikit';

interface IProps {
  date: string | null;
}

const Reports = ({ date }: IProps) => {
  const [keyword, setKeyword] = useState('');

  const onKeywordChange = useCallback((e: any) => {
    setKeyword(e?.target?.value ?? '');
  }, []);

  const {
    dataFlatten: data,
    isLoading,
    hasNextPage,
    onEndReached
  } = useFetchDashboardAllocationReportInfinity(date, keyword);

  const renderRow = useCallback((item: any) => {
    return (
      <KContainer.View
        row
        marginB={'1rem'}
        marginL={'0.5rem'}
        key={`r-${item.id}`}
      >
        <KContainer.View dp="flex" width={'100%'}>
          <KContainer.View
            dp="flex"
            row
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <KLabel.Text
              typo="TextLgBold"
              color={KColors.primary.normal}
              isLink
              onPress={() =>
                onShowContainer(item?.container, {
                  transportJobId: item?.container?.transportJobId,
                  selectedContainer: item?.container
                })
              }
            >
              {item.name}
            </KLabel.Text>
            <KButton.Icon
              icon="SaveAlt"
              onPress={() => window.open(item?.resource?.url, '_blank')}
            />
          </KContainer.View>
          {/* <br /> */}
          <KLabel.Text typo="TextMdBold" color={'#344767'}>
            {item.driverReport?.displayName}
            {/* {trans('created_by_person', {
              person: item.driverReport?.displayName ?? ''
            })} */}
          </KLabel.Text>
          {/* <br />
          <br /> */}
          <KLabel.Text color={'#7B809A'}>
            {Prototype.date.formatDT(item.createdAt)}
            {/* {trans('created_at')} {Prototype.date.formatDT(item.createdAt)} */}
          </KLabel.Text>
        </KContainer.View>
      </KContainer.View>
    );
  }, []);

  return (
    <>
      {isLoading && <KLoading />}

      <KContainer.View dp="flex" flex position="relative">
        {/* <KContainer.View row alignItems>
          <KContainer.View dp="flex" flex>
            <KLabel.Text typo="TextXNmMedium">{trans('report')}</KLabel.Text>
          </KContainer.View>

          <KContainer.View dp="flex" flex={1}>
            <KLabel.Text typo="TextXNmMedium">
              {trans('created_by')}
            </KLabel.Text>
          </KContainer.View>

          <KContainer.View dp="flex" flex={2}>
            <KLabel.Text typo="TextXNmMedium">{trans('type')}</KLabel.Text>
          </KContainer.View>

          <KContainer.View width={30} />
        </KContainer.View> */}
        <KContainer.View marginB="0.5rem">
          <KInput.Search
            width={230}
            fullWidth={false}
            value={keyword}
            placeholder={trans('search_placeholder')}
            name="allocationReportSearch"
            onChange={onKeywordChange}
            disabled={isLoading && data.length <= 0}
          />
          {/* <TextFieldSearch
            columns={generateOptions(ParentSource, {
              key: 'name',
              uppercase: false
            })}
            handleSearchValue={setSearchValue}
            handleChangeSearchField={setSearchField}
            mapColumns={mapMUITableColumnsToFilterColumns}
          /> */}
        </KContainer.View>

        <KContainer.View
          id="PODNotificationDiv"
          dp="flex"
          flex
          marginT={'0.75rem'}
        >
          <InfiniteScroll
            height={'100vh'}
            dataLength={data.length}
            next={onEndReached}
            hasMore={hasNextPage as any}
            loader={isLoading ? <KLoading /> : null}
            scrollableTarget="PODNotificationDiv"
            scrollThreshold={0.5}
            style={{
              flex: 1
            }}
          >
            {data ? (
              data.map(i => renderRow(i))
            ) : (
              <KLabel.Text typo="TextXNmMedium">
                {trans('no_data_found')}
              </KLabel.Text>
            )}
          </InfiniteScroll>
        </KContainer.View>
      </KContainer.View>
    </>
  );
};

export default memo(Reports);
